import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRunNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.783 0c-.492 0-.969.175-1.344.494l-2 1.7a.042.042 0 01-.013.008L.417 2.91A.625.625 0 000 3.5c0 1.05.134 1.834.387 2.459.258.636.622 1.063 1.009 1.418.193.178.381.331.563.48.545.446 1.04.851 1.488 1.735.693 1.714 1.576 3.093 2.954 4.03C7.784 14.56 9.584 15 12 15c1.368 0 2.312-.306 2.948-.785a2.596 2.596 0 001.002-1.554c.14-.657-.234-1.19-.6-1.484l-2.58-2.073a.708.708 0 01-.234-.346l-2.081-6.842A1.292 1.292 0 009.219 1h-.9c-.348 0-.682.14-.925.39l-.398.408-.335-1.14A.915.915 0 005.783 0zm-.534 1.446a.825.825 0 01.294-.16l.856 2.916 1.89-1.94a.042.042 0 01.03-.012h.9c.018 0 .034.012.04.03L10.087 5H8v1.25h2.467l.228.75H9v1.25h2.075l.266.872c.114.376.34.71.646.956l1.929 1.55c-.515.067-1.166.122-1.916.122-1.33 0-2.143-.27-2.723-.684-.592-.424-1.015-1.048-1.474-1.92-.15-.285-.302-.593-.463-.92-.75-1.523-1.7-3.453-3.662-5.444zM2.595 3.467c1.937 1.9 2.832 3.71 3.606 5.277.168.34.33.67.496.985.479.91 1.014 1.754 1.854 2.354.853.61 1.946.917 3.449.917 1.038 0 1.905-.097 2.516-.195l.062-.01a1.413 1.413 0 01-.38.421c-.357.268-1.009.534-2.198.534-2.275 0-3.796-.415-4.897-1.163-1.098-.746-1.86-1.88-2.506-3.487a.625.625 0 00-.021-.047C3.993 7.893 3.239 7.28 2.66 6.81c-.155-.125-.297-.24-.42-.354-.294-.27-.527-.55-.695-.967-.145-.358-.255-.844-.287-1.55z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRunNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRunNormalXsmall;
